import { useMemo } from 'react';

import useUser from 'Utilities/hooks/useUser';

import { getUserAttributesPayload } from './optimizely';

export const useOptimizelyUserAttributes = (): Record<string, Nullable<string>> => {
	const { dealerId, id } = useUser();

	return useMemo(() => getUserAttributesPayload({ dealerContactId: id, dealershipId: dealerId }), [dealerId, id]);
};
